<template>
    <div class="row">
        <div class="col-md-6 mg-t-10">
            <div class="card ht-100p">
                <div class="card-header d-flex align-items-center justify-content-between">
                    <h6 class="mg-b-0">Details</h6>
                    <div class="d-flex tx-18">
                        <a href="" class="link-03 lh-0"><i class="icon ion-md-refresh"></i></a>
                        <a href="" class="link-03 lh-0 mg-l-10"><i class="icon ion-md-more"></i></a>
                    </div>
                </div>
                <p v-if="company.company[0] == null" align="center"><bar-loader  class="custom-class" color="#6d0606" loading="loading" :size="150" sizeUnit="px"></bar-loader></p>
                <form v-else class="p-xl-2"  method="post">
                    <div class="form-group">
                        <label>Company Name:</label>
                        <input type="text" v-model="company.company[0].orgName" readonly class="form-control" name="CompanyName"  placeholder="Company Name">
                    </div>
                    <div class="form-group">
                        <label>Incorporation Number:</label>
                        <input type="text" v-model="company.company[0].orgIncNumber" readonly class="form-control" name="IncorporationNumber" placeholder="Incorporation Number">
                    </div>
                    <div class="form-group">
                        <label>Incorporation Date:</label>
                        <input type="text" v-model="company.company[0].orgIncDate" readonly class="form-control" name="IncorporationDate"  placeholder="Incorporation Date">
                    </div>
                    <div class="form-group">
                        <label>Organisation Type:</label>
                        <input type="text" v-model="company.company[0].orgType" readonly class="form-control" name="OrganisationType"  placeholder="Organisation Type">
                    </div>
<!--                    <button class="btn btn-brand-02 btn-block">Send Money</button>-->
                </form>
<!--                <div class="card-footer text-center tx-13">-->
<!--                    <a href="/customer/sendmoney" class="link-03">Go Back <i class="icon ion-md-arrow-down mg-l-5"></i></a>-->
<!--                </div>&lt;!&ndash; card-footer &ndash;&gt;-->
            </div><!-- card -->
        </div>
        <div class="col-md-6 mg-t-10">
            <div class="card ht-100p">
                <div class="card-header d-flex align-items-center justify-content-between">
                    <h6 class="mg-b-0">Address</h6>
                    <div class="d-flex tx-18">
                        <a href="" class="link-03 lh-0"><i class="icon ion-md-refresh"></i></a>
                        <a href="" class="link-03 lh-0 mg-l-10"><i class="icon ion-md-more"></i></a>
                    </div>
                </div>
                <p v-if="company.company[0] == null" align="center"><bar-loader  class="custom-class" color="#6d0606" loading="loading" :size="150" sizeUnit="px"></bar-loader></p>
                <form v-else class="p-xl-2"  method="post">
                    <div class="form-group">
                        <label>Street:</label>
                        <input type="text" v-model="company.company[0].orgStreet" readonly class="form-control" name="Street"  placeholder="Street">
                    </div>
                    <div class="form-row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>City:</label>
                                <input type="text" v-model="company.company[0].orgCity" readonly class="form-control" name="City" placeholder="City">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>State:</label>
                                <input type="text" v-model="company.company[0].orgState" readonly class="form-control" name="State" placeholder="State">
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Country:</label>
                                <input type="text" v-model="company.company[0].orgCountry" readonly class="form-control" name="Country" placeholder="Country">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Phone Number:</label>
                                <input type="text" v-model="company.company[0].orgPhone" readonly class="form-control" name="PhoneNumber" placeholder="Phone Number">
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Company Email:</label>
                                <input type="text" v-model="company.company[0].orgEmail" readonly class="form-control" name="Company Email" placeholder="Company Email">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Website:</label>
                                <input type="text" v-model="company.company[0].orgWebsite" readonly class="form-control" name="Website" placeholder="Website">
                            </div>
                        </div>
                    </div>
<!--                    <button class="btn btn-brand-02 btn-block">Send Money</button>-->
                </form>
<!--                <div class="card-footer text-center tx-13">-->
<!--                    <a href="/customer/sendmoney" class="link-03">Go Back <i class="icon ion-md-arrow-down mg-l-5"></i></a>-->
<!--                </div>&lt;!&ndash; card-footer &ndash;&gt;-->
            </div><!-- card -->
        </div>
    </div><!-- row -->
</template>

<script>
    // import FlotChart from "../FlotChart";
    import {mapState} from 'vuex'
    export default {
        name: "TopCards",
        components:{

        },
        computed:{
            ...mapState([
                'system',
                'company',
                'officer'
            ])
        }
    }
</script>

<style scoped>
    @media only screen and (min-width: 900px) {
        .top-card {
            width: 103%;
        }
    }
    @media only screen and (min-width: 707px) and (max-width: 900px) {
        .top-card {
            width: 104%;
        }
    }

    @media only screen and (min-width: 517px)  and (max-width: 707px) {
        .top-card {
            width: 105%;
        }
    }

    @media only screen and (min-width: 451px)  and (max-width: 517px) {
        .top-card {
            width: 106%;
        }
    }

    @media only screen  and (max-width: 451px) {
        .top-card {
            width: 107%;
        }
    }
</style>